import ExportModal from '../ExportModal';

/**
 * Bulk "Export selected" — renders ExportModal (a centered modal) for the
 * current selection. The bulk-action framework passes { caseId, ids, count,
 * onClose }; the anchor is unused since this is a modal, not a popover.
 */
export default function ExportPopover({ caseId, ids, count, onClose }) {
  return (
    <ExportModal
      caseId={caseId}
      scope="selection"
      documentIds={ids}
      count={count}
      label="selected files"
      onClose={onClose}
    />
  );
}
